import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const NomenclaturesService = {
  async getProductServices({ page, perPage }, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get(`productServices/`, {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientProductServices(clientId) {
    if (!clientId) {
      return;
    }

    const res = await axios.get(
      `mobile/productServices/?client_id=${clientId}`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createProductService(data) {
    const res = await axios.post('productServices/', data);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteProductService(id) {
    const res = await axios.delete(`productServices/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateProductService(id, data) {
    const res = await axios.put(`productServices/${id}/`, data);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async uploadExcelFile(clientId, data) {
    const res = await axios.post(`${clientId}/productServices/import`, data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },
};
